import { NightscoutContent } from "./NightscoutContent"
import { PageTemplate } from "src/components"
import { usePolyglot } from "src/contexts"

export function Nightscout() {
  const polyglot = usePolyglot()

  return (
    <PageTemplate
      user="account"
      title={polyglot.t("components.page_header.pages.nightscout")}
      backRoutePath="/account/data_source"
    >
      <NightscoutContent/>
    </PageTemplate>
  )
}
